import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-details-page',
  templateUrl: './instructors-details-page.component.html',
  styleUrls: ['./instructors-details-page.component.scss']
})
export class InstructorsDetailsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
